export default function InputField({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  required,
  helper,
  disabled = false,
  readOnly = false,
}) {
  return (
    <div className="flex flex-col">
      <label className="text-sm font-medium text-slate-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>

      <input
        type={type}
        disabled={disabled}
        readOnly={readOnly}  
        value={type !== "file" ? value ?? "" : undefined}
        onChange={(e) => {
          if (disabled || readOnly) return;   // 🔒 extra safety

          if (type === "file") {
            onChange(e);
          } else {
            onChange(e.target.value);
          }
        }}
        placeholder={placeholder}
        className={`w-full rounded-lg border px-3 py-2.5 text-sm outline-none
          ${disabled || readOnly ? "bg-gray-100 cursor-not-allowed" : ""}
          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
          ${error ? "border-red-400" : "border-slate-200"}
        `}
      />

      {helper && !error && (
        <p className="mt-1 text-xs text-slate-500">{helper}</p>
      )}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

  


// export default function InputField({
//   label,
//   type = "text",
//   value,
//   onChange,
//   placeholder,
//   error,
//   required,
//   helper,
//   disabled,
// }) {
//   return (
//     <div className="flex flex-col">
//       <label className="text-sm font-medium text-slate-700 mb-1">
//         {label}
//         {required && <span className="text-red-500 ml-0.5">*</span>}
//       </label>
//       <input
//         type={type}
//         disabled={disabled}
//         value={value || ""}
//         onChange={(e) => onChange(e.target.value)}
//         placeholder={placeholder}
//         className={`w-full rounded-lg border px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
//           error ? "border-red-400" : "border-slate-200"
//         }`}
//       />
//       {helper && !error && (
//         <p className="mt-1 text-xs text-slate-500">{helper}</p>
//       )}
//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// }